<template>
  <the-content v-model="showFilters">

    <template v-slot:content>
      <div :class="[$access('contract', 'c') ? 'contract-search-layout-create' : 'contract-search-layout']" class="mh2-l mv2">
        <search :placeholder="searchPlaceholder" @search="runSearch" @reset="resetSearch"/>
        <create-button v-if="$access('contract', 'c')" :loading="creating" title="Создать" @click="createContract" class="db" id="create_contract_button"/>
      </div>
      <content-spinner v-if="loading" class="ma3"/>
      <div v-else-if="contracts.length > 0">
        <div class="list-grid mh2-l mt2">
          <list-item v-for="(contract, index) in contracts" :key="index" :contract="contract" :direction="validParams.direction" />
        </div>
        <div class="pv3 flex justify-center" v-if="totalCount">
          <paginator :page="validParams.page" routing="false" :total="totalCount" @goto="paginatorRoute"/>
        </div>
      </div>
      <div v-else class="pa2 f6 ttl silver">
        По вашему запросу ничего не найдено
      </div>
    </template>

    <template v-slot:sidebar>
      <filters
        :checked="validParams.statuses"
        :sort="validParams.sort"
        :direction="validParams.direction"
        :procedure="{ id: validParams.procedure }"
        :stats="stats"
        :placeholders="placeholders"
        @updated="filterRoute"
      />
    </template>

    <template v-slot:mobile-sidebar>
      <filters
        :checked="validParams.statuses"
        :sort="validParams.sort"
        :direction="validParams.direction"
        :procedure="{ id: validParams.procedure }"
        :stats="stats"
        :placeholders="placeholders"
        @updated="filterRoute"
      />
    </template>

  </the-content>
</template>

<script>
import TheContent from '@/components/Content.vue'
import ListItem from '@/components/contracts/ListItem.vue'
import Filters from '@/components/contracts/Filters.vue'
import ContentSpinner from '@/components/common/ContentSpinner.vue'
import Search from '@/components/common/Search.vue'
import Paginator from '@/components/Paginator.vue'
import CreateButton from '@/components/ui/Button.vue'
import { DataService } from '@/services/DataService.js'

export default {
  components: {
    TheContent,
    ListItem,
    Filters,
    Search,
    ContentSpinner,
    Paginator,
    CreateButton
  },
  props: {
    params: { type: Object }
  },
  watch: {
    validParams: {
      immediate: true,
      handler: function (validParams) {
        const direction = validParams.direction === 'all' ? null : validParams.direction
        const apiParams = {
          filter: {
            ...direction && { direction: direction.toUpperCase() },
            ...validParams.statuses.length > 0 && { status_code: validParams.statuses },
            ...validParams.search && { search: validParams.search },
            ...validParams.procedure && { procedure: parseInt(validParams.procedure) }
          },
          sort: validParams.sort.toUpperCase(),
          offset: (validParams.page - 1) * this.limit,
          limit: this.limit
        }
        this.loading = true
        this.loadContracts(apiParams).finally(() => { this.loading = false })
        this.loadContractStats(apiParams)
      }
    }
  },
  data () {
    return {
      placeholders: {
        company: this.sp === 'out' ? 'Контрагент' : 'Организатор'
      },
      searchPlaceholder: 'поиск договоров',
      showFilters: false,
      loading: false,
      creating: false,
      // NEW
      limit: 10,
      stats: {},
      contracts: [],
      totalContracts: 0
    }
  },
  computed: {
    validParams () {
      const statuses = Array.isArray(this.params.statuses)
        ? this.params.statuses
        : this.params.statuses ? [this.params.statuses] : []
      return {
        direction: this.params.direction || 'all',
        page: this.params.page || 1,
        sort: this.params.sort || 'desc',
        statuses,
        search: this.params.search,
        procedure: this.params.procedure
      }
    },
    totalCount () {
      return this.totalContracts % this.limit
        ? Math.floor(this.totalContracts / this.limit) + 1
        : this.totalContracts / this.limit
    }
  },
  methods: {
    paginatorRoute (where) {
      this.$router.push({ name: this.$router.name, query: this.filterEmpty({ ...this.validParams, page: where.query.page }) })
    },
    filterRoute (update) {
      this.$router.push({ name: this.$router.name, query: this.filterEmpty({ ...this.validParams, ...update, page: 1 }) })
    },
    runSearch (value) {
      this.$router.push({ name: this.$router.name, query: this.filterEmpty({ ...this.validParams, ...{ search: value }, page: 1 }) })
    },
    resetSearch () {
      this.$router.push({ name: this.$router.name, query: this.filterEmpty({ ...this.validParams, ...{ search: null }, page: 1 }) })
    },
    filterEmpty (params) {
      return this.$lo.pickBy(params, (value, key) => value)
    },
    createContract () {
      this.creating = true
      return DataService.createContract({})
        .then(({ data: { create_contract: { id } } }) => {
          this.$router.push({ name: 'contract_card', params: { id: id } })
        })
        .catch((e) => {
          console.error(`[Create contract error: Message: ${e}`)
        })
        .finally(() => {
          this.creating = false
        })
    },
    // NEW
    async loadContracts (params) {
      return DataService.getContracts(params)
        .then(async ({ data: { contract: { data: contracts, total_count: totalCount } } }) => {
          this.contracts = contracts
          this.totalContracts = totalCount
        })
    },
    async loadContractStats (params) {
      const { data: { contract_stats: contractStats } } = await DataService.getContractStats(params)
      this.stats = contractStats.reduce(function (map, obj) {
        map[obj.group] = obj.count || 0
        return map
      }, {})
    },
    async loadContractsCompanies (contracts) {
      const companiesIds = contracts?.reduce((acc, cont) => {
        if (cont.company_id) {
          acc.add(cont.company_id)
        }
        if (cont.subsidiary_id) {
          acc.add(cont.subsidiary_id)
        }
        if (cont.counteragent_company_id) {
          acc.add(cont.counteragent_company_id)
        }
        return acc
      }, new Set([]))
      return DataService.getCompanies({ filter: { id: Array.from(companiesIds) }, offset: 0, limit: 10000 })
        .then(({ data: { company: { data } } }) => {
          // this.companies = data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.contract-search-layout-create {
  display: grid;
  grid-template-columns: auto 130px;
  grid-template-rows: auto;
  column-gap: .5rem;
}
.contract-search-layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  column-gap: .5rem;
}
</style>
